import { useNavigate } from 'react-router-dom';
import { ReactComponent as BackIcon } from '../../assets/btn_gnb_back.svg';
import { ReactComponent as PcBackIcon } from '../../assets/btn_gnb_back44.svg';
import styled from 'styled-components';
import useIsMobile from '../../hooks/useIsMobile';

const BackButton = ({ style }: { style?: React.CSSProperties }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <Button type="button" onClick={() => navigate(-1)} style={style}>
      {isMobile ? <BackIcon /> : <PcBackIcon />}
    </Button>
  );
};

export default BackButton;

const Button = styled.button`
  background: inherit;
  border: none;
  box-shadow: none;
  border-radius: 0;
  padding: 0;
  overflow: visible;
  cursor: pointer;
`;
